import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface HeaderProps {
  isAuthenticated?: boolean;
  userRole?: string;
  onLogout?: () => void;
}

const Header: React.FC<HeaderProps> = ({ isAuthenticated, userRole, onLogout }) => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header className="bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 shadow-lg border-b-4 border-yellow-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo y título */}
          <div className="flex items-center space-x-4">
            <div className="flex-shrink-0">
              <div className="flex items-center space-x-3">
                {/* Logo UNLP */}
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md">
                  <div className="w-10 h-10 bg-blue-900 rounded-full flex items-center justify-center">
                    <span className="text-white text-xs font-bold">UNLP</span>
                  </div>
                </div>
                
                {/* Texto institucional */}
                <div className="hidden md:block">
                  <div className="text-white">
                    <div className="text-sm font-medium">Facultad de</div>
                    <div className="text-lg font-bold">Informática</div>
                  </div>
                </div>
                
                {/* Separador vertical */}
                <div className="hidden md:block w-px h-8 bg-yellow-400"></div>
                
                {/* Título del sistema */}
                <div className="text-white">
                  <div className="text-sm font-medium">Portal</div>
                  <div className="text-lg font-bold">Académico</div>
                </div>
              </div>
            </div>
          </div>

          {/* Navegación */}
          <nav className="hidden md:flex items-center space-x-8">
            {isAuthenticated ? (
              <>
                {(userRole === 'admin' || userRole === 'jtp') && (
                  <>
                    <Link
                      to="/admin"
                      className={`text-sm font-medium transition-colors ${
                        isActive('/admin')
                          ? 'text-yellow-300 border-b-2 border-yellow-300'
                          : 'text-white hover:text-yellow-200'
                      }`}
                    >
                      Dashboard
                    </Link>
                    <Link
                      to="/admin/alumnos"
                      className={`text-sm font-medium transition-colors ${
                        isActive('/admin/alumnos')
                          ? 'text-yellow-300 border-b-2 border-yellow-300'
                          : 'text-white hover:text-yellow-200'
                      }`}
                    >
                      Alumnos
                    </Link>
                    <Link
                      to="/admin/profesores"
                      className={`text-sm font-medium transition-colors ${
                        isActive('/admin/profesores')
                          ? 'text-yellow-300 border-b-2 border-yellow-300'
                          : 'text-white hover:text-yellow-200'
                      }`}
                    >
                      Profesores
                    </Link>
                    <Link
                      to="/admin/cursos"
                      className={`text-sm font-medium transition-colors ${
                        isActive('/admin/cursos')
                          ? 'text-yellow-300 border-b-2 border-yellow-300'
                          : 'text-white hover:text-yellow-200'
                      }`}
                    >
                      Cursos
                    </Link>
                    <Link
                      to="/admin/turnos"
                      className={`text-sm font-medium transition-colors ${
                        isActive('/admin/turnos')
                          ? 'text-yellow-300 border-b-2 border-yellow-300'
                          : 'text-white hover:text-yellow-200'
                      }`}
                    >
                      Turnos
                    </Link>
                    <Link
                      to="/admin/inscripciones"
                      className={`text-sm font-medium transition-colors ${
                        isActive('/admin/inscripciones')
                          ? 'text-yellow-300 border-b-2 border-yellow-300'
                          : 'text-white hover:text-yellow-200'
                      }`}
                    >
                      Inscripciones
                    </Link>
                    <Link
                      to="/admin/notas"
                      className={`text-sm font-medium transition-colors ${
                        isActive('/admin/notas')
                          ? 'text-yellow-300 border-b-2 border-yellow-300'
                          : 'text-white hover:text-yellow-200'
                      }`}
                    >
                      Notas
                    </Link>
                  </>
                )}
                {userRole === 'profesor' && (
                  <>
                    <Link
                      to="/profesor/cursos"
                      className={`text-sm font-medium transition-colors ${
                        isActive('/profesor/cursos')
                          ? 'text-yellow-300 border-b-2 border-yellow-300'
                          : 'text-white hover:text-yellow-200'
                      }`}
                    >
                      Mis Cursos
                    </Link>
                    <Link
                      to="/profesor/notas"
                      className={`text-sm font-medium transition-colors ${
                        isActive('/profesor/notas')
                          ? 'text-yellow-300 border-b-2 border-yellow-300'
                          : 'text-white hover:text-yellow-200'
                      }`}
                    >
                      Cargar Notas
                    </Link>
                  </>
                )}
              </>
            ) : (
              <Link
                to="/"
                className={`text-sm font-medium transition-colors ${
                  isActive('/')
                    ? 'text-yellow-300 border-b-2 border-yellow-300'
                    : 'text-white hover:text-yellow-200'
                }`}
              >
                Inscripción de Alumnos
              </Link>
            )}
          </nav>

          {/* Acciones del usuario */}
          <div className="flex items-center space-x-4">
            {isAuthenticated ? (
              <div className="flex items-center space-x-3">
                <div className="text-white text-sm">
                  <div className="font-medium">
                    {userRole === 'admin' ? 'Administrador' : 
                     userRole === 'jtp' ? 'JTP' : 'Profesor'}
                  </div>
                </div>
                <button
                  onClick={onLogout}
                  className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors shadow-md"
                >
                  Cerrar Sesión
                </button>
              </div>
            ) : (
              <Link
                to="/login"
                className="bg-yellow-500 hover:bg-yellow-600 text-blue-900 px-4 py-2 rounded-lg text-sm font-bold transition-colors shadow-md"
              >
                Iniciar Sesión
              </Link>
            )}
          </div>
        </div>
      </div>

      {/* Barra de información adicional */}
      <div className="bg-blue-950 py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between text-xs text-blue-200">
            <div className="flex items-center space-x-4">
              <span>Universidad Nacional de La Plata</span>
              <span>•</span>
              <span>Por la Ciencia y por la Patria</span>
            </div>
            <div className="text-yellow-300 font-medium">
              Sistema de Gestión Académica
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
